module.exports = __webpack_public_path__ + "static/media/logo.7fd77dcc.webp";